export const exceptions_email = [
    // 'francesca.tardelli@processfactory.it',
    // 'stefano.delgobbo@gmail.com',
    // 'rpiacentini@scrspa.it',
    // 'laboratorio@antiba.it',
    // 'giacomo.p@bcn.it',
    // 'qualita@tessituragiussani.com',
    // 'sustainability.milano@bonaudo.com',
    //'mauro.regaldi@loropiana.com'
    // 'a.bettarini@cilp.it',
    // 'i.carrozzo@isaseta.it',
    // 'raffaele.guzzon@miroglio.com',
    // 'csr@vitalebarberiscanonico.it',
    // 'eugenio.dellapiana@miroglio.com',
    // 'g.esposito@vignolanobile.com',
    // 'elena@conceriabertini.it',
    // 'michele@nuovaimpala.com',
    // 'maurizio@laboratoriobest.com',
    // 'davidbiondi@dolmenspa.com',
    // 'lrosticci@quadrif.it',
    // 'bnacci@quadrif.it',
    // 'o.gorga@leoshoes.it',
    // 'andreana.errichiello@guerrierosrl.com',
    // 'edoardo.baldini@conceriavaldarno.it',
    // 'sustainability@lanificiodisordevolo.com',
];